// extracted by mini-css-extract-plugin
export var bottom = "styles-module--bottom--d9f7e";
export var entityCard = "styles-module--entityCard--9130a";
export var image = "styles-module--image--c89cc";
export var imagePlaceholder = "styles-module--imagePlaceholder--bf7d5";
export var subline = "styles-module--subline--c129b";
export var title = "styles-module--title--6ffc7";